import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { MenuItem, Menu, withStyles } from '@material-ui/core';
import { Button, Icon } from 'shared/components';
import { FilterIconWithHint } from 'modules/queues/common/components/AppointmentsFilter';

import theme from './SortBy.scss';
import SortDirectionIcon from './components/SortDirectionIcon';


const ResetSortMenuItem = withStyles({
  root: {
    padding: 0,
    cursor: 'default',
    background: 'none',
    '&:hover': { background: 'none' },
    '&:active': { background: 'none' },
  },
})(MenuItem);


const SortBy = ({
  anchorEl,
  openPopover,
  closePopover,

  sortFields,
  activeSortField,
  iconTooltipMessage,
  iconName,
  setSortField,
  resetSort,

  intl,
  classes,
}) => (
  <Fragment>
    <FilterIconWithHint
      openPopover={ openPopover }
      activeFilters={ activeSortField }
      iconTooltipMessage={ iconTooltipMessage }
      iconName={ iconName }
    />

    <Menu
      anchorEl={ anchorEl }
      open={ !!anchorEl }
      onClose={ closePopover }
      getContentAnchorEl={ null }
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PopoverClasses={{
        paper: classes.topArrow,
      }}
    >
      { sortFields.map(field => {
        const hasActiveSortField = activeSortField && field.key === activeSortField.field;

        return (
          <MenuItem
            key={ field.key }
            onClick={ () => setSortField(field.key) }
            selected={ hasActiveSortField }
            className={ classnames(theme.filterItem, { [theme.active]: hasActiveSortField }) }
          >
            <SortDirectionIcon direction={ hasActiveSortField && activeSortField.direction } />

            <span className={ theme.filterItemLabel }>
              <FormattedMessage { ...field.label } />
            </span>

            <Icon name="check" className={ theme.filterCheckIcon } />
          </MenuItem>
        );
      }) }

      <ResetSortMenuItem onClick={ resetSort } disableRipple={ true } role="button">
        <Button
          testId="reset-appointments-sort"
          className={ theme.resetSort }
          buttonType="naked"
          iconName="naked-x"
          size="xsmall"
          label={ intl.formatMessage({
            id: 'Appointments.AppointmentsList.ClearSort.Button.Label',
            defaultMessage: '** Clear sort',
          }) }
          labelColor="blackMedium"
          iconPositionLeft
          iconPositionRtlNotReversed
        />
      </ResetSortMenuItem>
    </Menu>
  </Fragment>
);

export default withStyles(({ topArrow }) => ({ topArrow }))(SortBy);
